import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { RequestEntity, IItemGame, UserRoles } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { GamesContext, IGamesContext } from 'modules/Entertainment/Games/Games/gamesState/gamesContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemGame;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion } = useContext<IGamesContext>(GamesContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const hasDeleteAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasEditAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const isAssigned = data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.openInfo]: isOpenInfo,
		[style.itemAssigned]: isAssigned,
	});
	const nameRowClasses = classNames(style.row, style.name);
	const gameNameRowClasses = classNames(style.row, style.name);
	const developerRowClasses = classNames(style.row, style.developer);
	const categoryRowClasses = classNames(style.row, style.category);
	const applicationIdRowClasses = classNames(style.row, style.applicationId);
	const versionCodeRowClasses = classNames(style.row, style.versionCode);
	const versionNameRowClasses = classNames(style.row, style.versionName);
	const actionRowClasses = classNames(style.row, style.action);

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={nameRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Games}
							entityID={data.iconPath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							noImageIdIcon="gameDefaultAvatar"
						/>
					</div>
					<Text
						className={gameNameRowClasses}
						translationKey={data.name}
						withTooltip={true}
						data-test="gameName"
					/>
				</div>
				<Text
					className={developerRowClasses}
					translationKey={data.developerName}
					withTooltip={true}
					data-test="developer"
				/>
				<Text
					className={categoryRowClasses}
					translationKey={data.gameCategoryName}
					withTooltip={true}
					data-test="category"
				/>
				<Text
					className={applicationIdRowClasses}
					translationKey={data.applicationId}
					withTooltip={true}
					data-test="applicationId"
				/>
				<Text
					className={versionCodeRowClasses}
					translationKey={String(data.versionCode)}
					withTooltip={true}
					data-test="versionCode"
				/>
				<Text
					className={versionNameRowClasses}
					translationKey={data.versionName}
					withTooltip={true}
					data-test="versionName"
				/>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickDelete={hasDeleteAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasEditAccess ? `/entertainment/games/edit?gameID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
